import { Loader2 } from 'lucide-react';

const GlobalLoader = () => {
  return (
    <div className="min-h-[calc(100vh-5rem)] w-full flex items-center justify-center bg-white">
      <Loader2 className="h-12 w-12 animate-spin text-primary" />
    </div>
  );
};

export default GlobalLoader;
